
export  function isArrayValid(arr) {
    return Array.isArray(arr) && arr.length > 0;
}

export function isValidObject(obj) {
    return obj && Object.keys(obj).length > 0;
}
